var _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedThumbnailGray = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 102,
    viewBox: "0 0 104 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 102.795,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    transform: "rotate(90 102.795 0.5)",
    fill: "#B9BEC6",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-hand-shadow",
    d: "M24.8058 62.0001C31.878 62.8987 34.6295 61.483 38.3058 60.5001C43.1267 45.5769 37.9657 36.9373 34.8058 35.5001C31.6459 34.0629 26.9515 36.137 25.7665 38.8864C24.8185 41.086 12.9493 41.334 2.21451 41.4199C2.21451 59.9199 2.21451 56.4199 2.21451 56.4199L13.3058 56.4199C13.6393 57.0837 17.7336 61.1014 24.8058 62.0001Z",
    fill: "#67717E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2643 35.6779L102.214 9.91992C102.214 9.91992 102.214 31.4199 102.214 47.9334C102.214 64.447 102.214 85.9199 102.214 85.9199L62.2643 60.7699C62.2643 60.7699 58.4144 55.9862 58.4144 47.9334C58.4144 39.8807 62.2643 35.6779 62.2643 35.6779Z",
    fill: "url(#paint0_linear_357_9486)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M14.2145 47.7835C14.2145 44.4375 16.6019 41.568 19.8921 40.9594L25.3151 39.9563V55.5484L19.9686 54.6213C16.6429 54.0446 14.2145 51.1588 14.2145 47.7835Z",
    fill: "#505862"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight",
    d: "M25.3149 40.426H51.8792V56.0182H25.3149C25.3149 56.0182 22.6841 55.2803 22.6841 48.2221C22.6841 41.1639 25.3149 40.426 25.3149 40.426Z",
    fill: "#67717E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M72.7972 47.7526C72.7972 56.4524 68.6629 63.5051 63.5631 63.5051C62.9013 63.5051 62.2557 63.3863 61.6334 63.1606L56.4671 60.6177L49.1271 56.8916C47.6627 56.1482 46.4454 54.9693 46.022 53.3825C45.6661 52.0491 45.3345 50.179 45.3345 47.84C45.3345 45.4588 45.6782 43.5635 46.0412 42.2258C46.4592 40.6856 47.631 39.5317 49.0417 38.7853L57.0767 34.5345L61.6334 32.3445C62.2557 32.1188 62.9013 32 63.5631 32C68.6629 32 72.7972 39.0527 72.7972 47.7526Z",
    fill: "#505862"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-flashlight-lens",
    cx: 64.4557,
    cy: 48.0297,
    rx: 6.54485,
    ry: 13.5709,
    fill: "#D5D8DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-highlight",
    d: "M56.2747 45.9122C56.2747 39.7202 59.0124 35.8917 59.6755 34.9399C56.0822 37.0574 49.4539 39.8486 47.9653 41.1319C46.4767 42.4152 46.4895 44.8535 46.3291 46.5538L56.2747 45.9122Z",
    fill: "#9DA4AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-shadow",
    d: "M24.9547 41.6357C25.0174 41.4861 25.1639 41.3887 25.3262 41.3887H44.7812C45.0545 41.3887 45.2485 41.6551 45.1646 41.9152L44.7829 43.0986C44.7292 43.265 44.5743 43.3778 44.3995 43.3778H24.8299C24.5421 43.3778 24.3471 43.0846 24.4584 42.8191L24.9547 41.6357Z",
    fill: "#505862"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2442,
    cy: 42.5114,
    r: 1.76454,
    fill: "#22262A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-flashlight-bulb",
    d: "M58.7118 52.7592C58.7373 52.9802 58.9377 53.1404 59.1559 53.0966C60.2013 52.8866 61.1522 52.3359 61.8561 51.525C62.6484 50.6123 63.0704 49.4361 63.039 48.2279C63.0076 47.0197 62.5251 45.867 61.6864 44.9967C60.9413 44.2235 59.9631 43.723 58.9082 43.5675C58.688 43.5351 58.4962 43.7055 58.4822 43.9275L58.2482 47.6359C58.218 48.1134 58.2305 48.5927 58.2854 49.068L58.7118 52.7592Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fingers",
    d: "M43.3432 50.0664C45.2833 52.2797 47.7145 55.6436 45.7145 57.1826C43.6868 58.7428 42.2254 58.1023 40.6896 56.2928C41.9142 58.4143 42.3107 59.807 40.2145 60.9198C38.6115 61.7708 37.3142 61.5339 36.2157 60.6663C36.609 61.8978 36.248 62.9114 34.2145 63.4198C32.2807 63.9033 30.9802 63.4303 29.9595 62.4842C29.8033 62.8447 29.285 63.1522 28.2145 63.4198C26.2145 63.9198 24.4925 62.827 22.8177 59.9785C21.635 57.5594 20.1834 51.7143 21.7145 50.9198C23.1564 50.1716 23.819 50.5131 24.3312 51.5271C24.0066 50.1034 24.0258 48.8607 24.6947 48.0942C25.7862 46.8435 27.7193 47.9194 29.7534 50.4095C28.6364 48.1706 28.0183 46.2132 28.9673 45.5815C30.9659 44.251 33.8174 46.7739 35.9482 49.2762C35.0329 47.6336 34.3285 45.8858 34.8522 44.9965C35.9311 43.1642 42.9356 49.5873 43.3432 50.0664Z",
    fill: "#F1F2F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M23.7146 61.4197C25.869 64.3518 27.4949 63.798 28.2146 63.4197C23.0063 60.2376 22.8019 54.6765 21.7146 50.9197C21.7146 50.9197 20.2146 51.1335 20.7146 54.4197C20.9428 55.9197 21.0215 57.7547 23.7146 61.4197Z",
    fill: "#505862"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M38.6625 53.6913C41.5398 58.0913 43.2145 58.9199 45.2145 57.4199C41.9207 54.7815 37.0427 48.0547 35.0154 44.7712C33.7146 45.9199 34.9643 48.0361 38.6625 53.6913Z",
    fill: "#505862"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-hand",
    d: "M38.3058 41.4999C41.3058 41.4999 43.7185 39.2638 41.3057 37.4999C38.8928 35.736 31.3059 32.4999 27.8058 32.4999C22.2832 32.4999 18.8058 32.9999 9.74086 37.9294C7.77436 39.2062 6.30571 38.5459 2.2144 37.9055L2.21441 43.9999L11.8058 43.9999C14.3058 45.4999 18.8058 45.6422 20.8058 45.4999C24.8058 45.2154 29.3058 40.4999 29.3058 40.4999C31.8971 40.5704 31.3383 40.4999 33.8058 40.4999C35.8058 40.4999 35.3058 41.4999 38.3058 41.4999Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M32.7144 56.9199C36.7145 63.9199 40.2145 60.9199 40.2145 60.9199C40.2145 60.9199 31.5072 51.0515 28.7145 45.9199C27.8496 46.9667 28.3386 49.2622 32.7144 56.9199Z",
    fill: "#505862"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-finger-shadows",
    d: "M27.7146 59.4197C30.47 64.6556 32.04 63.8412 34.2145 63.4197C30.4674 59.0607 26.0251 53.7314 24.4437 48.295C23.4994 50.809 24.2703 52.8748 27.7146 59.4197Z",
    fill: "#505862"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_9486",
    x1: 59.7145,
    y1: 47.9199,
    x2: 100.714,
    y2: 47.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedThumbnail-gray.9639ef03dd721c638e9d66af199138a8.svg";